/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = FrontPadsAndDiscs
 *
 * 1 = FrontBrakesOther
 *
 * 2 = RearPadsAndDiscs
 *
 * 3 = RearBrakesOther
 *
 * 4 = Misc
 */
export enum VHCRecordCheckBrakeItemTypes {
  FrontPadsAndDiscs = 0,
  FrontBrakesOther = 1,
  RearPadsAndDiscs = 2,
  RearBrakesOther = 3,
  Misc = 4,
}
